module.exports = __webpack_public_path__ + "static/media/ashish-vaidya.4e862b94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/avatars/ashish-vaidya.jpg
// module id = 820
// module chunks = 0